import {Injectable,OnInit,OnDestroy} from '@angular/core';
import {AuthService} from '../../common/services/permission';
import {Subscription} from 'rxjs';
import {Subject} from 'rxjs';
import {GlobalState} from '../../global.state';
import {Router} from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
@Injectable()
export class LoginService implements OnInit, OnDestroy{
private _subscriptions:Array<Subscription>=[];
private apiUrl:string;
constructor(private http:HttpClient,private gblstate:GlobalState,public authSerice:AuthService,private router:Router) { 
     
}

    ngOnInit(){

    }
    userProfile:Subject<any>;
    mockLogin(username:string,password:string){
        
    }
    login(username: string, password: string) {
        let arr =this.gblstate.getGlobalSetting("apiUrl");
        if(arr){this.apiUrl=arr[0]}
        //console.log(this.apiUrl);
        //console.log({ username: username, password: password });
        let headers = new HttpHeaders({ 'content-type':'application/json'});
        let option = { headers };
        return this.http.post( this.apiUrl +'/jwt', { UserId: username, Password: password },option)
            .pipe(map((user: any) => {
                    if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    this.authSerice.setAuth(user)
                     
                     //console.log(user);
                     this.gblstate.setGlobalSetting("LoggedIn",[true])
                     //console.log(this.gblstate.getGlobalSetting("LoggedIn"))
                     this.gblstate.setGlobalSetting("View-Permission",['Divisions','smartTables','addDivision']);
                     //console.log(this.gblstate.getGlobalSetting("View-Permission"))
                }
            }));
    }

    refreshToken(){
         let option = { withCredentials: true };
        return this.http.post( this.apiUrl +'/refreshToken', { },option)
    }

    logout() {
        // remove user from local storage to log user out
        let arr =this.gblstate.getGlobalSetting("apiUrl");
        if(arr){this.apiUrl=arr[0]}
        let reqOptions =  this.authSerice.getRequestOption();
        let sub = this.http.get(this.apiUrl +"/logout",reqOptions)
            .subscribe((res:any)=>{
                if(res.status=='ok'){
                    this.router.navigate(['/']);
                }
            },error=>{alert(error);}
            )
        this._subscriptions.push(sub);
        this.authSerice.removeAuth();
        window.sessionStorage.removeItem('currentUser');
        this.gblstate.notifyDataChanged("LoggedIn",false);
        this.gblstate.setGlobalSetting("LoggedIn",[false]);
        this.gblstate.setGlobalSetting("View-Permission",[]);
        
        //this.cacheService.remove('currentUser');
        
        
    }

    ngOnDestroy(){
        this._subscriptions.forEach(sub=>{ sub.unsubscribe();})
    }

}